import storage from 'Helpers/storage';

const FAVORITE_PROMPTS_STORAGE_KEY = 'panther.ai.favoritePrompts';

export const getFavoritePrompts = (): string[] => {
  return storage.local.read<string[]>(FAVORITE_PROMPTS_STORAGE_KEY) ?? [];
};

export const addFavoritePrompt = (prompt: string): void => {
  const favorites = getFavoritePrompts();
  if (!favorites.includes(prompt)) {
    storage.local.write(FAVORITE_PROMPTS_STORAGE_KEY, [...favorites, prompt]);
  }
};

export const removeFavoritePrompt = (prompt: string): void => {
  const favorites = getFavoritePrompts();
  storage.local.write(
    FAVORITE_PROMPTS_STORAGE_KEY,
    favorites.filter(p => p !== prompt),
  );
};

export const isPromptFavorited = (prompt: string): boolean => {
  return getFavoritePrompts().includes(prompt);
};
